export default __webpack_public_path__ + "static/media/customCraft.4f329d00.jpg";